/**
 * Logging utility with deduplication
 */

import { DEBUG, LOG_DEDUP_TIMEOUT } from './config';

// Log deduplication - store recent messages to avoid duplicates
const recentLogs = new Map();

// Helper to deduplicate logs
function logWithDeduplication(level, message, data = '') {
  // Create a unique key from the message and stringified data
  let dataStr = '';
  
  try {
    if (typeof data === 'object' && data !== null) {
      // For arrays, include the length to differentiate between different arrays
      if (Array.isArray(data)) {
        dataStr = `Array(${data.length})`;
      } else {
        // For objects, just use the constructor name
        dataStr = data.constructor.name;
      }
    } else {
      dataStr = String(data || '');
    }
  } catch (e) {
    dataStr = 'CannotStringify';
  }
  
  const key = `${message}_${dataStr.substring(0, 30)}`; // Truncate data for key
  
  // Check if this exact message was logged recently
  if (recentLogs.has(key)) {
    return;
  }
  
  // Log the message
  if (level === 'error') {
    console.error(message, data);
  } else if (level === 'important') {
  } else if (DEBUG) {
  }
  
  // Add to recent logs and set timeout to remove
  recentLogs.set(key, Date.now());
  
  // Clean up old logs
  setTimeout(() => {
    recentLogs.delete(key);
  }, LOG_DEDUP_TIMEOUT);
}

// Simplified logger
export const logger = {
  info: (message, data) => {
    if (DEBUG) {
      logWithDeduplication('info', message, data);
    }
  },
  error: (message, error) => {
    logWithDeduplication('error', message, error);
  },
  important: (message, data) => {
    logWithDeduplication('important', message, data);
  }
};

// Export a function that components can use to deduplicate their logs
export function logMessage(message, data = '') {
  logWithDeduplication('component', message, data);
} 